import { isProductionEnvironment } from "~/Context";

export const isTesting = (): boolean => typeof jest !== 'undefined'

export enum Environment {
	STAGING = 'staging',
	PRODUCTION = 'production',
	DEVELOPMENT = 'development',
	TESTING = 'testing',
}

export const getEnvironment = (): Environment => {
	return isProductionEnvironment() ? Environment.PRODUCTION : Environment.STAGING
}
